module.exports = __webpack_public_path__ + "static/media/9.62a5c780.jpg";